import React from 'react';


import {SkeletonItem} from 'src/components/skeleton';
import {WidthItem} from 'src/components/width-item';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

export const UserActivitySkeleton = () => (
    <FormSection headline="User Activity" info={() => <SkeletonItem width={170} height={28}/>}>
        <Group direction="v">
            <Group>
                <WidthItem width={230}>
                    <SkeletonItem width={123} height={17}/>
                </WidthItem>
                <WidthItem width={140}>
                    <SkeletonItem width={123} height={17}/>
                </WidthItem>
            </Group>
            <Group>
                <WidthItem width={230}>
                    <SkeletonItem width={123} height={17}/>
                </WidthItem>
                <WidthItem width={140}>
                    <SkeletonItem width={123} height={17}/>
                </WidthItem>
            </Group>
        </Group>
    </FormSection>
);
